/*
 |--------------------------------------------------------------------------
 | Document Ready Function
 |--------------------------------------------------------------------------
 */

$(function () {
    'use strict';

    /**
     * Account - modify avatar (input type file)
     */
    $('.avatar-file').change(function () {
        var fileName = this.files[0].name;
        $('.avatar-name').text(fileName);
        $('.user-avatar, .btn-save').removeClass('hidden');
        $('.btn-avatar').toggleClass('block hidden');
    });

    /**
     * Make inputs accept only numbers.
     */
    $('.input-number').keypress(function (e) {
        if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) return false;

        var maxlength = $(this).attr('maxlength'),
            value = $(this).val().length;

        if (value >= maxlength) return false;
    });

    /**
     * Scroll to the element by clicking.
     */
    $('.display-health-units').on('click', (e) => {
        e.preventDefault();

        let top = $('.health-units').position().top - 65;
        $('html, body').animate({ scrollTop: top }, 1000);
    });
});
